exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods_info .info[data-v-75d6c97e]{margin-left:10px}.goods_info .info p[data-v-75d6c97e]{color:#666666}.goods_info .info p[data-v-75d6c97e]:first-child{color:#999999}.dropClass[data-v-75d6c97e]{margin-right:10px}\n", ""]);

// exports
